<template>
    <div class="shellCase1">
      <div class="top">
        <div class="topImg1"></div>
        <div class="topImg1Z">
          <h3 style="margin-top: 180px;text-align: center;color: #fff;font-size: 40px;">PARTY BUILDING</h3>
          <p style="width: 2px;background-color: #fff;height: 30px;margin: 10px auto;"></p>
          <p style="text-align: center;color: #fff;"><span class="spanHover" @click="openRouterOne">首页</span>
            &nbsp;&nbsp;>&nbsp;&nbsp;<span
              class="spanHover" @click="openRouter1">弹壳少年
  
            </span>&nbsp;&nbsp;>&nbsp;&nbsp;<span class="spanHover">半日营</span></p>
        </div>
        <ul>
          <li @click="openRouter1">假日营</li>
          <li @click="openRouter2">夏令营</li>
          <li @click="openRouter3">冬令营</li>
          <li @click="openRouter4">军事营</li>
          <li @click="openRouter5">一日营</li>
          <li class="ulLi" @click="openRouter6">半日营</li>
        </ul>
      </div>
      <div class="wrap">
        <h3 style="text-align: center;">{{ title }}
        </h3>
        <p style="height: 30px;margin: 10px;"><span style="float: right;">浏览次数:{{ browse }}</span><span
                style="float: right;margin-right: 20px;">发布日期：{{ time }}</span> </p>
        <div v-html="content"></div>
      </div>
    </div>
  </template>
  
  
  <script>
  export default {
    name: "Header",
    data() {
      return {
        content: '',
            title: '',
            browse: '',
            time: '',
            img:''
      }
    },
    mounted() {
        this.$axios
            .get("/system/content/getContentDetails", { params: { id: this.$route.query.id } })
            .then(res => {
                if (res.code == 0) {
                    this.content = res.data.content
                    this.title = res.data.title
                    this.browse = res.data.num
                    this.time = res.data.time.slice(0, 10)
                } else {
                    this.$message.closeAll();
                    this.$message.error(res.msg);
                }
            });
    },
    methods: {
      openRouter1() {
        this.$router.push({
          path: "/shellCase1",
        });
      },
      openRouter2() {
        this.$router.push({
          path: "/shellCase2",
        });
      },
      openRouter3() {
        this.$router.push({
          path: "/shellCase3",
        });
      },
      openRouter4() {
        this.$router.push({
          path: "/shellCase4",
        });
      },
      openRouter5() {
        this.$router.push({
          path: "/shellCase5",
        });
      },
      openRouter6() {
        this.$router.push({
          path: "/shellCase6",
        });
      },
      openRouterOne(){
        sessionStorage.setItem("top","0");
        this.$router.push({
          path: "/",
        });
      },
    }
  };
  </script>
  
  <style scoped>
  .shellCase1 {
    width: 100%;
  
    .spanHover:hover {
      color: #2589ff;
      cursor: pointer;
    }
  
    .top {
      width: 100%;
      position: relative;
  
      .topImg1 {
        height: 460px;
        background: url(../../assets/shellCaseTop.jpg) no-repeat scroll 0 0;
        padding: 0 0 110px 0;
      }
  
      .topImg1Z {
        position: absolute;
        width: 100%;
        height: 460px;
        top: 0;
        left: 0;
        background: rgba(45, 62, 80, 0.8) none repeat scroll 0 0;
      }
  
      ul {
        list-style: none;
  
        margin: 0 auto;
        display: flex;
        text-align: center;
        justify-content: center;
  
        .ulLi {
          color: #0086d1;
        }
  
        li {
          padding: 20px;
        }
  
        li:hover {
          cursor: pointer;
        }
      }
    }
  
    .wrap {
      width: 1200px;
      margin: 0 auto;
      margin-bottom: 30px;
  
      .tj1A {
        padding: 0 20px;
        color: #4c4c4c;
        font-family: 'montserratregular';
        font-size: 24px;
        margin-bottom: 10px;
      }
  
      .tj1B {
        padding: 0 20px;
        color: #4c4c4c;
        font-family: 'montserratregular';
        font-size: 14px;
      }
  
      .tj1C {
        padding: 0 20px;
        margin: 20px 0 50px 0;
  
        span {
          background: #0086d1;
          color: #fff;
          padding: 8px 20px;
          font-size: 14px;
        }
      }
  
      .tj1:hover {
        img {
          cursor: pointer;
        }
  
        .tj1A {
          color: #0086d1;
          cursor: pointer;
        }
  
        .tj1C {
  
          span {
            background: #181a1b;
            color: #fff;
            padding: 8px 20px;
            font-size: 14px;
            cursor: pointer;
          }
        }
      }
    }
  }
  </style>